import type { ReactElement } from 'react';
import { Fragment } from 'react';
import { weekAndMonthDay } from 'utils/dateTimes';

import UpcomingMenu, { Shipment } from 'models/UpcomingMenu';
import useCurrentUser from 'hooks/useCurrentUser';
import FetchState from 'models/FetchState';
import FulfillmentStatus from '../../../models/FulfillmentStatus';

type Props = {
  item: UpcomingMenu;
  className?: string;
};

function TrackingNumbers({ shipments }: { shipments: Shipment[] }) {
  return (
    <div className="c-order__tracking">
      <strong>
        {shipments && shipments.length > 1
          ? 'Tracking numbers: '
          : 'Tracking number: '}
      </strong>

      {shipments && shipments.map((shipment, index) => (
        <Fragment key={shipment.tracking_number}>
          <a
            href={shipment.delivery_tracking_url}
            target="_blank"
            rel="noreferrer"
            className={
              shipments.length > 1
                ? 'u-text--truncate'
                : undefined
            }
          >
            {shipment.tracking_number}
          </a>
          {index !== shipments.length - 1 && ', '}
        </Fragment>
      ))}

      {(!shipments || !shipments.length) && (
        <span className="u-text u-text--muted">
          Pending
        </span>
      )}
    </div>
  );
}

function SkipLabel({
  item,
  className,
}: Props): ReactElement {
  const { fetchState } = useCurrentUser();

  const {
    fulfillment_status: fulfillmentStatus,
    isPast,
    isEnabled,
    skip_deadline: skipDeadline,
    shipments,
  } = item;
  const showPastDeadline = isPast && isEnabled;

  const getSkipText = () => {
    if (showPastDeadline) {
      return (<strong>Past skip deadline: </strong>);
    }
    if (fulfillmentStatus === FulfillmentStatus.SKIPPED) {
      return 'Unskip order by ';
    }
    return 'Skip order by ';
  };

  if (fetchState === FetchState.IN_PROGRESS) {
    // @ts-expect-error TODO: fix null safety
    return null;
  }
  return (
    <div className={className}>
      <div className="c-order__deadline">
        {getSkipText()}
        {weekAndMonthDay(skipDeadline)}
      </div>

      {showPastDeadline && (
        <TrackingNumbers shipments={shipments} />
      )}
    </div>
  );
}

export default SkipLabel;
